export const INCOME = 'INCOME';
export const EXPENSE = 'EXPENSE';
